import { Type } from '@sinclair/typebox';
export const handlingSchema = Type.Object({
    price: Type.Number(),
});
//# sourceMappingURL=handling.js.map